import { Component, ElementRef, ViewChild } from '@angular/core';
import { IFloatingFilterParams } from 'ag-grid-community';
import { AgFloatingFilterComponent } from 'ag-grid-angular';
import { SymbolRecord } from '../../../../shared/components/symbol-search/symbol-search.model';
import { SymbolSearchComponent } from '../../../../shared/components/symbol-search/symbol-search.component';

@Component({
    selector: 'symbol-filter-component',
    templateUrl: './symbol-filter.component.html',
    standalone: true,
    imports: [SymbolSearchComponent]
})
export class SymbolFilterComponent implements AgFloatingFilterComponent {
  @ViewChild('eInput', { read: ElementRef, static: true }) eInput: ElementRef;
  params: IFloatingFilterParams;
  currentValue: Number | null | string = null;

  agInit(params: IFloatingFilterParams): void {
    this.params = params;
  }

  symbolFilterSelected(symbolRecord: SymbolRecord): void {
    if (symbolRecord && symbolRecord.fundSymbol) {
      this.params.parentFilterInstance((instance: any) => {
        instance.onFloatingFilterChanged('equals', symbolRecord.fundSymbol);
      });
    } else {
      this.params.parentFilterInstance((instance: any) => {
        instance.onFloatingFilterChanged(null, null);
      });
    }
  }

  onParentModelChanged(parentModel: any): void {
    // When the filter is empty we will receive a null value here
    if (!parentModel) {
      this.currentValue = null;
    } else {
      this.currentValue = parentModel.filter;
    }
  }
}
